import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import deepmerge from "deepmerge";

@Injectable()
export class AppResource {
  private resource: any = null!;
  constructor(private readonly http: HttpClient) {}
  public getResource(key: string) {
    return key;
  }

  public load(brand: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const baseRequest = this.http.get(`../locale/common/fr.json`);
      if (baseRequest) {
        baseRequest.subscribe((responseData: any) => {
          this.resource = responseData;
          const brandRequest = this.http.get(`./locale/${brand}/configuration.json`);
          if (brandRequest) {
            brandRequest.subscribe((responseData: any) => {
              this.resource = deepmerge(this.resource, responseData);
              resolve();
            });
          } else {
            console.error('Locale resource file "configuration.json" is not valid');
            reject();
          }
        });
      } else {
        console.error('Locale resource file "base.json" is not valid');
        reject();
      }
    });
  }
}
